import React from 'react'
import {
   AIFinancialIcon,
   ContinuousSupportIcon,
   CustomFintechIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureTransactionsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Fintech Software',
      subtitle: 'Tailored Solutions for Financial Services',
      description:
         'We create tailored fintech applications, such as digital banking, payment gateways, and investment platforms, for smooth financial management.',
      icon: <CustomFintechIcon />,
   },
   {
      title: 'AI-Powered Financial Insights',
      subtitle: 'Predictive Analytics & Risk Assessment',
      description:
         'We implement AI-driven financial analytics that monitor expenditure patterns, detect possible fraud threats, and make better financial decisions, subsequently making better investments.',
      icon: <AIFinancialIcon />,
   },
   {
      title: 'Secure & Compliant Transactions',
      subtitle: 'End-to-End Encryption & Data Security',
      description:
         'Using blockchain-based security, fraud detection, and multi-factor authentication, we uphold PCI-DSS, GDPR, and financial compliance standards.',
      icon: <SecureTransactionsIcon />,
   },
   {
      title: 'Seamless System Integration',
      subtitle: 'Banking APIs, ERP & Payment Systems',
      description:
         'We create fintech platforms that can easily be integrated with banking APIs, ERP solutions, cryptocurrency exchanges, and AI-based fraud detection systems for efficient financial processes.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'Optimized Performance & Global Transactions',
      description:
         'Our cloud-powered fintech solutions support real-time financial transactions, multi-currency processing, and scalable payment infrastructures, enabling business expansion.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Regulatory Compliance & Feature Enhancements',
      description:
         'We offer 24/7 technical support, security updates, and feature updates to ensure fintech platforms are compliant, secure, and future-proof.',
      icon: <ContinuousSupportIcon />,
   },
];
 
function FinWhyChoose() {
   return (
      <WhyChooseOur
      classCustom='fintech_custom_why_choose'
         title={'Why Select Our Fintech Development Services?'}
         desc={
            'We provide innovative fintech solutions that are scalable, reliable, and enhance financial transactions while automating compliance and streamlining banking processes. Here’s why businesses choose Benzatine:'
         }
         cardData={featureCards}
      />
   )
}

export default FinWhyChoose
